module.exports = __webpack_public_path__ + "media/images/webpage/specials/huistenbosch_2020/cover-5-7b49db8649a6ca5ca8b31689ce6df1b4.webp";